import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/award-xero-mapping'
)({
  beforeLoad: () => {
    throw redirect({
      to: '/organizations/settings/integrations',
    })
  },
  component: () => null,
})
